// Finds every installed browser wallet (MetaMask, Bitget/BitKeep, Azaance, Trust, OKX, Coinbase...) via EIP-6963 plus legacy globals
const announced = new Map();

if (typeof window !== "undefined") {
  window.addEventListener("eip6963:announceProvider", (e) => {
    const { info, provider } = e.detail || {};
    if (provider) announced.set(provider, info?.name || "Wallet");
  });
  window.dispatchEvent(new Event("eip6963:requestProvider"));
}

const LEGACY = [
  ["Bitget Wallet", () => window.bitkeep?.ethereum],
  ["OKX Wallet", () => window.okxwallet],
  ["Trust Wallet", () => window.trustwallet],
  ["Coinbase Wallet", () => window.coinbaseWalletExtension],
  ["Browser wallet", () => window.ethereum],
];

export function installedWallets() {
  const found = new Map(announced);
  for (const [name, get] of LEGACY) {
    const p = get();
    if (p?.request && ![...found.keys()].includes(p)) found.set(p, name);
  }
  return [...found].map(([provider, name]) => ({ provider, name }));
}
